import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { GridRowId } from '@mui/x-data-grid-pro';
import QueryKeys from '@src/constants/queryKeys';
import useDeviceMutations from '@src/hooks/api/mutations/useDeviceMutations';
import { CollectionPayload } from '@src/types/Collection';
import { DeviceExtended } from '@src/types/Device';
import { useQueryClient } from '@tanstack/react-query';
import { Dispatch, SetStateAction } from 'react';

interface DialogProps {
  jsonData: CollectionPayload;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleCancel: (id?: GridRowId) => () => void;
}

function DeleteDeviceDialog({ jsonData, handleCancel, setOpen }: DialogProps) {
  const { id } = jsonData as DeviceExtended;
  const queryClient = useQueryClient();

  const { deleteDevice } = useDeviceMutations(id);

  const handleDeviceDelete = () =>
    deleteDevice.mutate(
      {},
      {
        onSuccess: async () => {
          const invalidations = [
            queryClient.invalidateQueries({
              queryKey: [QueryKeys.devices],
            }),
            queryClient.invalidateQueries({
              queryKey: [QueryKeys.widgetDeviceList],
            }),
          ];
          await Promise.all(invalidations);
          setOpen(false);
        },
      },
    );

  return (
    <Dialog open>
      <DialogContent>
        <FormattedAlias id='Are you sure you want to delete?' />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel(id)}>
          <FormattedAlias id='Cancel' />
        </Button>
        <Button size='small' variant='contained' onClick={handleDeviceDelete}>
          <FormattedAlias id='Confirm' />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteDeviceDialog;
